export const accountAbstractionVersion1 = 1
